import { useEffect, useState } from "react";
import { useLogin } from "../../context/Login/LoginContext";
import { useSnackbar } from "notistack";
import {
    Typography,
    Box,
    CircularProgress,
    Paper,
    Stack,
    Button
} from "@mui/material";
import { fetchUsers } from "./userService";
import { SearchAndFilterSection } from "./SearchAndFilterSection";
import { UserCountAndSortSection } from "./UserCountAndSortSection";
import { UserCard } from "./UserCard";
import UserDetails from "./UserDetails";
import User from "../../types/User";
import Profile from "../Profile/Profile";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import * as XLSX from 'xlsx';

const UsersList = () => {
    const [users, setUsers] = useState<User[]>([]);
    const [loading, setLoading] = useState(true);
    const { enqueueSnackbar } = useSnackbar();

    const [selectedUser, setSelectedUser] = useState<User | null>(null);

    const [location, setLocation] = useState("");
    const [sortBy, setSortBy] = useState("fullName");
    const [sortOrder, setSortOrder] = useState("desc");
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        fetchUserData();
    }, [searchQuery, location, sortBy, sortOrder]);

    const fetchUserData = async () => {
        try {
            const usersData = await fetchUsers(searchQuery, location, sortBy, sortOrder);
            const filteredUsers = usersData.filter(user => !user.disabled);
            setUsers(filteredUsers);
        } catch (error) {
            enqueueSnackbar("Error when fetching users", { variant: "error" });
        } finally {
            setLoading(false);
        }
    };

    const handleUserClick = (userId: string) => {
        const user = users.find(user => user._id === userId);
        if (user) {
            setSelectedUser(user);
        }
    };

    return (
        <Stack maxWidth={1} alignItems="center" overflow="auto">
            <Stack width="80%" m={2} >
                <SearchAndFilterSection searchQuery={searchQuery} setSearchQuery={setSearchQuery} location={location} setLocation={setLocation} />
                <UserCountAndSortSection usersCount={users.length} users={users} sortOrder={sortOrder} setSortOrder={setSortOrder} sortBy={sortBy} setSortBy={setSortBy} />
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                        <CircularProgress />
                    </Box>
                ) : users.length === 0 ? (
                    <Paper sx={{ p: 4, textAlign: 'center' }}>
                        <Typography variant="h6">No users found</Typography>
                    </Paper>
                ) : (
                    <Stack direction="row" gap={2}>
                        <Stack flex={1} overflow="auto" gap={1} >
                            {users.map((user) => (
                                <UserCard
                                    key={user._id}
                                    user={user}
                                    selectedUserId={selectedUser?._id ?? ""}
                                    onClick={handleUserClick}
                                />
                            ))}
                        </Stack>

                        <Box flex={2} position="sticky" top={10} sx={{ maxHeight: "90dvh", overflow: "auto" }}>
                            {/* {selectedUser && <Profile id={selectedUser._id} />} */}
                            <UserDetails user={selectedUser} />
                        </Box>
                    </Stack>
                )}
            </Stack>
        </Stack>
    );
}

export default UsersList; 